import {selector} from "./selector";
import * as events from "./events";

const PageCustomerProfileHistory = (function ($) {
    function initEvents() {
        $(document).on('change', selector.ddlBank, events.getBank);
        $(document).on("click", selector.btnComplaintModal, events.openComplaintModal);
        $(document).on("click", selector.btnObjectionModal, events.openObjectionModal);
        $(document).on("click", selector.btnHistoryExport, events.historyExportExcel);
        $(document).on("click", selector.btnHistoryExportPdf, events.historyExportPdf);
        $(document).on("click", selector.inputDate, function () {
            $(".datepicker-days").css("display", "block");
        });
        $(document).on("click", selector.countryTab, events.changeCountryHistory);
    }

    function initialize() {
        initEvents();
        $(selector.inputDate).datepicker({
            format: "dd/mm/yyyy",
            autoclose: true,
            orientation: "bottom",
        });
        $(document).ready(function() {
            $('#filter_date_from').on('input', function() {
                const input = this;
                const dateValue = new Date(input.value);

                if (!input.value) {
                    $(input).removeClass('is-invalid');
                    return;
                }
        
                const minDate = new Date('1900-01-01');
                const maxDate = new Date('2099-12-31');

                let value = $(input).val();
                let digitCount = value.replace(/\D/g, '').length;
                let maxDigits = 8; 

                // Check if the date value is valid and within range
                if (digitCount > maxDigits || dateValue < minDate || dateValue > maxDate || isNaN(dateValue)) {
                    let newValue = value.replace(/\d(?=\d{4})/g, '');
                    $(this).val(newValue); 
                }
            });
            $('#filter_date_to').on('input', function() {
                const input = this;
                const dateValue = new Date(input.value);

                if (!input.value) {
                    $(input).removeClass('is-invalid');
                    return;
                }
        
                const minDate = new Date('1900-01-01');
                const maxDate = new Date('2099-12-31');
        
                // Check if the date value is valid and within range
                let value = $(input).val();
                let digitCount = value.replace(/\D/g, '').length;
                let maxDigits = 8; 

                if (digitCount > maxDigits || dateValue < minDate || dateValue > maxDate || isNaN(dateValue)) {
                    let newValue = value.replace(/\d(?=\d{4})/g, '');
                    $(this).val(newValue); 
                }
            });
        });
    }

    return {
        init: initialize,
    };
})(jQuery);

export {PageCustomerProfileHistory};
